// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from 'react';
import { useConfig } from '../../../contexts/ConfigContext';
import './InterviewCard.css';

interface InterviewCardProps {
  children: React.ReactNode;
  showHeader?: boolean;
}

const InterviewCard: React.FC<InterviewCardProps> = ({ children, showHeader = true }) => {
  const { config, logo } = useConfig();
  return (
    <div className="interview-card">
      {showHeader && (
        <div className="interview-card-header">
          <div className="interview-card-logo">
            <img src={logo as string} alt={`${config?.companyName || 'G42'} Logo`} width={25} height={25} />
          </div>
          <h1 className="interview-card-title">Interviewer Host</h1>
        </div>
      )}
      <div className="interview-card-content">{children}</div>
    </div>
  );
};

export default InterviewCard;
